import { backendApi } from "@/services/backend/api";
import { Filter } from "@/shared/lib/filter/filter";
import {
  providesEntity,
  providesList,
} from "@/services/backend/_lib/tag-helpers";
import { RFC3339timestamp, UUID } from "@bitory-gmbh/nidavellir";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import { Lst } from "@/shared/lib/lst/lst";
import { AirHandlingUnit } from "../types/air-handling-unit";

const ahuApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["HtzAirHandlingUnit"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      htzAirHandlingUnitPut: build.mutation<AirHandlingUnit, PutRequest>({
        query: (request) => ({
          url: `/htz/air-handling-unit`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: (_result, _e, request) => [
          { type: "HtzAirHandlingUnit", id: request.id },
          "HtzAirHandlingUnit",
        ],
      }),
      htzAirHandlingUnitShow: build.query<AirHandlingUnit, ShowRequest>({
        query: (request) => ({
          url: `/htz/air-handling-unit`,
          method: "GET",
          params: request,
        }),
        providesTags: providesEntity("HtzAirHandlingUnit"),
      }),
      htzAirHandlingUnitList: build.query<Lst<AirHandlingUnit>, ListRequest>({
        query: (request) => ({
          url: `/htz/air-handling-unit/list`,
          method: "GET",
          params: {
            request: btoa(JSON.stringify(request)),
          },
        }),
        providesTags: (result) =>
          providesList(result?.items, "HtzAirHandlingUnit"),
      }),
      htzAirHandlingUnitDelete: build.mutation<null, DeleteRequest>({
        query: (request) => ({
          url: `/htz/air-handling-unit`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: ["HtzAirHandlingUnit"],
      }),
    }),
  });

export const {
  useHtzAirHandlingUnitPutMutation,
  useHtzAirHandlingUnitShowQuery,
  useLazyHtzAirHandlingUnitShowQuery,
  useHtzAirHandlingUnitListQuery,
  useLazyHtzAirHandlingUnitListQuery,
  useHtzAirHandlingUnitDeleteMutation,
} = ahuApi;

export type PutRequest = AirHandlingUnit;

export interface ShowRequest {
  id: string;
}

export interface ListRequest {
  name?: Filter<string>;
  company?: Filter<UUID>;
  customer?: Filter<UUID>;
  serviceObject?: Filter<UUID>;
  createdAt?: Filter<RFC3339timestamp>;
  updatedAt?: Filter<RFC3339timestamp>;
  orderBy?: OrdrBy<"name" | "createdAt" | "updatedAt">[];
  limit?: number;
  offset?: number;
}

export interface DeleteRequest {
  id: string;
}
